import React from 'react'
import Switch from 'react-switch'
import { connect } from 'react-redux'

// Components
import ModalCodingTestRequired from 'app/views/components/Modals/Info/ModalCodingTestRequired'
import ModalOverrideOrganizationDefault from 'app/views/components/Modals/Info/ModalOverrideOrganizationDefault'

// Redux
import { updateTeamMustPassCode } from 'app/state/modules/team'


class EditSettings extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mustPassCode: this.props.currentTeam.must_pass_coding_exercise,
    }
    this.handleOverRide = this.handleOverRide.bind(this)
    this.handleUpdateMustPassCode = this.handleUpdateMustPassCode.bind(this)
  }

  handleOverRide(value) {
    this.setState({
      mustPassCode: value === true ? false : null,
    }, () => {
      this.props.updateTeamMustPassCode(
        this.props.match.params.organization_uuid,
        this.props.match.params.team_uuid,
        value === true ? false : '',
      )
    })
  }

  handleUpdateMustPassCode(value) {
    this.setState({
      mustPassCode: value,
    }, () => {
      this.props.updateTeamMustPassCode(
        this.props.match.params.organization_uuid,
        this.props.match.params.team_uuid,
        value,
      )
    })
  }

  render() {
    return (
      <>
        <h2>Settings</h2>
        <div className="uk-margin">
          <label className="uk-form-label">Coding Test Required</label>
          <div className="uk-inline">
            <Switch
              onChange={this.handleOverRide}
              checked={this.state.mustPassCode !== null}
              id="normal-switch"
              offColor="#999999"
              onColor="#1e87f0"
              checkedIcon={false}
              uncheckedIcon={false}
            />
            <span style={{ paddingLeft: 10, verticalAlign: 'top' }}>
              Override Organization Default
            </span>
            <span
              data-uk-icon="icon: info; ratio: 0.8"
              data-uk-toggle="target: #modal-info-override-organization-default"
              style={{
                cursor: 'pointer',
                paddingLeft: 8,
                paddingTop: 6,
                verticalAlign: 'top',
              }}
            />
            <ModalOverrideOrganizationDefault />
          </div>
        </div>
        {this.state.mustPassCode !== null && (
          <div className="uk-margin">
            <div
              className="uk-inline"
            >
              <Switch
                onChange={this.handleUpdateMustPassCode}
                checked={this.state.mustPassCode}
                id="normal-switch"
                offColor="#999999"
                onColor="#1e87f0"
                checkedIcon={false}
                uncheckedIcon={false}
              />
              <span style={{ paddingLeft: 10, verticalAlign: 'top' }}>
                Coding Test Required
              </span>
              <span
                data-uk-icon="icon: info; ratio: 0.8"
                data-uk-toggle="target: #modal-info-coding-test-required"
                style={{
                  cursor: 'pointer',
                  paddingLeft: 8,
                  paddingTop: 6,
                  verticalAlign: 'top',
                }}
              />
              <ModalCodingTestRequired />
            </div>
          </div>
        )}
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  currentTeam: state.team.currentTeam,
})

export default connect(mapStateToProps, {
  updateTeamMustPassCode,
})(EditSettings)
